import { Layer as ParseLayer } from '@meitu-graphic/ag-psd';
import { type ILayerProps } from '@meitu/saas-editor-core-next/es/version-types';

/**
 * 图层名称来源
 */
export enum LayerNameSource {
    /**
     * 画板
     * @description {@link https://helpx.adobe.com/cn/photoshop/using/artboards.html|画板}
     */
    ArtBoard = 'artb',
    /** 组 */
    Group = 'lset',
    /** 形状 */
    Shape = 'shap',
    /** 背景图层 */
    Background = 'bgnd',
}

export type UploadImage = (file: File, extension?: string) => Promise<string>;

/**
 *  告警类型
 */
export enum PsdParseWarnType {
    Warn = 'warn',
    Error = 'error',
    Info = 'info',
}

export enum PsdParseErrorType {
    UploadApi = 'uploadApi',
    Network = 'network',
}

export type WarnOrErrorCallbackFunc = (
    info: string,
    warnType: PsdParseWarnType,
    layerId?: string,
    errorType?: PsdParseErrorType,
) => void;

export interface IStage {
    clientLayers: ILayerProps[];
    preview: string;
    stageWidth: number;
    stageHeight: number;
    replaceFonts: any[];
    name: string;
    settingType: string;
}

export interface IParsePsdToClientTemplateResult {
    psdChild?: ParseLayer[];
    name: string;
    resolution: number;
    stages: IStage[];
    psdFile?: File;
}
